let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fa8gP")).then(() => parcelRequire('gbfWz'));